/**
 * create params string for URL
 * @param {Object} params params
 * @returns {string} params string
 */
function getParameters(params) {
    return Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');
}

/**
 * Append params in url
 * @param {string} url url
 * @param {Object} params map of params to append
 * @returns {string} new url
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + getParameters(params);
    return newUrl;
}


/**
 * get current url origin (Protocol + Domain)
 * SFRA provides lot of relatives urls without the origin (ex : "/on/demandware.store/Sites-KENZO_FR-Site/fr_FR/Cart-RemoveCouponLineItem" )
 * if you are using the https://developer.mozilla.org/en-US/docs/Web/API/URL URL interface
 * you sometimes need the origin/protocol/domain or the url will not be consider as valid
 * @returns {string} current url protocol
 */
function getCurrentOrigin() {
    var currentUrl = new URL(window.location.href);
    return currentUrl.origin;
}

module.exports = {
    appendToUrl: appendToUrl,
    getParameters: getParameters,
    getCurrentOrigin: getCurrentOrigin
};
